<!-- prettier-ignore -->

<div class="chat-bot-info-container">
    <div class="chat-bot-info-container__header">
        <div style="display: flex;">
            <svg xmlns="http://www.w3.org/2000/svg" width="29" height="30" viewBox="0 0 29 30" fill="none">
                <mask id="mask0_1_1884" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="29" height="30">
                <rect y="0.5" width="29" height="29" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_1_1884)">
                <path d="M14.5 8.95829C14.8423 8.95829 15.1293 8.84249 15.3609 8.6109C15.5925 8.3793 15.7083 8.09232 15.7083 7.74996C15.7083 7.4076 15.5925 7.12062 15.3609 6.88902C15.1293 6.65742 14.8423 6.54163 14.5 6.54163C14.1576 6.54163 13.8706 6.65742 13.639 6.88902C13.4074 7.12062 13.2916 7.4076 13.2916 7.74996C13.2916 8.09232 13.4074 8.3793 13.639 8.6109C13.8706 8.84249 14.1576 8.95829 14.5 8.95829ZM13.2916 18.625H15.7083V11.375H13.2916V18.625ZM2.41663 27.0833V5.33329C2.41663 4.66871 2.65326 4.09979 3.12652 3.62652C3.59979 3.15326 4.16871 2.91663 4.83329 2.91663H24.1666C24.8312 2.91663 25.4001 3.15326 25.8734 3.62652C26.3467 4.09979 26.5833 4.66871 26.5833 5.33329V19.8333C26.5833 20.4979 26.3467 21.0668 25.8734 21.5401C25.4001 22.0133 24.8312 22.25 24.1666 22.25H7.24996L2.41663 27.0833ZM6.22288 19.8333H24.1666V5.33329H4.83329V21.1927L6.22288 19.8333Z" fill="#1C1B1F"/>
                </g>
            </svg>
        </div>
        <span>{{ 'Información sobre el chatbot' | translate }}</span>
    </div>
    <div class="chat-bot-info-container__body">
        <span>
            {{'Este es un chatbot potenciado por un modelo de lenguaje de inteligencia artificial. Como LLM, es posible que se produzcan errores puntuales o información no respaldada por esta institución. Por ello, siempre recomendamos contrastar la información con los canales oficiales de la institución para mayor certeza.' | translate }} 
        </span>
    </div>
    <div class="chat-bot-info-container__footer">
        <button (click)="closeModal()">{{ 'Confirmar' | translate }}</button>
        
    </div>
</div>